import { ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { CommonService } from 'src/app/_services/common.service';
import { DashboardService } from '../../services/dashboard.service';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute,Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';

declare let $: any;
@Component({
  selector: 'my-tangram-dashboard',
  templateUrl: './my-tangram-dashboard.component.html',
  styleUrls: ['./my-tangram-dashboard.component.scss']
})
export class MyTangramDashboardComponent implements OnInit {
  isDashboard: boolean = true;
  isMobile: boolean = false;
  iconPath = appConfig.iconPath;
  videoData:null;
  /** pathway detail */
  public pathwayDetail: any = {
    title: '',
    description: ''
  }
  public ratingCounts = {};
  userRatings = {}; // To store user video ratings
  public videosDuration = { totalVideo: '', totalVideoMinutes: '' }; // To store videos duration details
  /** pass curated info to the component */
  public curatorInfo: any = {
    _id: null,
    firstName: '',
    lastName: ''
  };
  /** pass content processed data to the component */
  public contentProcessed: any = {
    data: 0
  };
  public currentVideoDetail: any = { _id: '' }; // To store current video detail
  public trackVideoDetail = {}; // To store track video detail
  upskills: any[]; // To store upskills

  playlists: any[]; // To store playlist

  spotlights: any[]; // To store spotlights
  videoId: string = ""; // To store video id
  // upskill scroll event for mobile
  @ViewChild('upskillWeb', { static: false }) upskillWeb: ElementRef;
  showDashboardSubScription: Subscription;
  scrollToUpSkillSubScription: Subscription;
  openSpotLightModalSubScription: Subscription;
  changeViewSubscription: Subscription;
  showDashboardOverviewView: boolean = true; // To show hide dashboard overview view
  showForumView: boolean = false; // To show hide forum view
  showForumQuestionView: boolean = false; //To show hide forum question view
  tag: any;
  pathwayId: string = ""; // To store pathway id
  overviewImageUrl: string = ""; // To store image url
  showFeedbackModal: boolean;
  visibility: string = ""; // To check id public page or not
  publicVisibility: boolean = false;
  currentUser: any;
  constructor(
    private cd: ChangeDetectorRef,
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private commonService: CommonService
    ) {
      this.currentUser = this.authService.currentUserValue;
    }

  ngOnInit() {
    this.activatedRoute.params.subscribe((param) => {
      if (this.activatedRoute.parent.snapshot.routeConfig.path == 'video/:id') {
        this.visibility = 'public';
        this.publicVisibility = true;
      }
      this.getOverviewDetail();
      // Set isFromAM if available
      if (param.id) {
        this.isDashboard = false;
        // this.currentVideoDetail = param.video;
        this.videoId = param.id;
        this.getVideoDetail(param.id,'manual', 'public');
        // console.log("videoData",this.videoData)
        // this.pathwayDetail = { title: video.title, description: video.description, tagName: video.tag.name };
        // this.isFromAccountManagement = param.isFromAM == "true";
      }
    });
    //call subscription
    this.showDashboardSubScription = this.commonService.showDashboard.subscribe((param: any) => {
      param ? this.onDashboardClick() : '';
    });
    this.scrollToUpSkillSubScription = this.commonService.scrollToUpSkill.subscribe(() => {
      // scroll to particular div-upskill
      this.upskillWeb.nativeElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
    this.openSpotLightModalSubScription = this.commonService.openSpotLightModal.subscribe((param: boolean) => {
      param ? this.openSpotLightModal() : '';
    });
    this.handleChangeViewSubscription();
  }

  /**
  * Called once, before the instance is destroyed.
  */
  ngOnDestroy(): void {
    this.showDashboardSubScription ? this.showDashboardSubScription.unsubscribe() : '';
    this.scrollToUpSkillSubScription ? this.scrollToUpSkillSubScription.unsubscribe() : '';
    this.openSpotLightModalSubScription ? this.openSpotLightModalSubScription.unsubscribe() : '';
    this.renderer.removeClass(document.body, 'video-detail-page');
  }

  /**
   * Get overview detail
   */
  getOverviewDetail() {
    if(this.currentUser || this.visibility !== 'public') {
      if (this.isDashboard) {
        this.renderer.removeClass(document.body, 'video-detail-page');
      }
      this.callFooterCommonEvent();
      this.dashboardService.getOverviewDetail().subscribe((data: any) => {
        // Bind curator information
        this.curatorInfo = data.data.admin;
        // Extract necessary details from response
        const { _id, title, description, imageURL, ratingCounts, totalVideos, totalDurationMIN, videos, upskills, totalVideoWatchPercentage } = data.data;
        this.pathwayId = _id;
        // Bind pathway id in localstorage
        localStorage.setItem("pathwayId", this.pathwayId);
        if (imageURL) {
          this.overviewImageUrl = `${environment.backendUrl}${imageURL}`;
        }
        else {
          this.overviewImageUrl = "assets/img/videos/main-iamge.png";
        }

        this.commonService.raiseEventToGetPathwayInHeaderAndFooter(this.pathwayId);
        // Bind total video watch percentage for overview
        this.contentProcessed.data = totalVideoWatchPercentage;
        // Bind detail like title and description
        this.pathwayDetail = { title, description };
        // Bind different counts like users, likes, comments, questions
        this.ratingCounts = ratingCounts;
        this.videosDuration = { totalVideo: totalVideos, totalVideoMinutes: totalDurationMIN };
        // if (this.playlists == undefined) {
        // Bind videos
        this.playlists = videos;
        // }
        // Bind upskills
        this.upskills = upskills;
      }, error => {
        if (error.status == 400 && error.error.message == "Please select topic") {
          this.router.navigate(['/configuration/preferences/5']);
        }

      });
    }
  }

  /**
   * Get video detail
   */
  getVideoDetail(videoId,from='', visibility='') {
    if (!this.isDashboard) {
      this.renderer.addClass(document.body, 'video-detail-page');
    }
    this.callFooterCommonEvent();
    if (visibility == 'public') {
      this.dashboardService.getVideoDetailPublic(videoId).subscribe((data: any) => {
        const { spotlights, ratingCounts, isLiked, tag, isDisliked, isFavourite } = data.data;
        if(from=='manual'){
          this.currentVideoDetail = data.data;
          this.pathwayDetail = { title: data.data.title, description: data.data.description, tagName: data.data.tag.name };
        }
        this.pathwayId = data.data.pathwayId;
        this.commonService.raiseEventToGetPathwayInHeaderAndFooter(data.data.pathwayId);
        this.ratingCounts = ratingCounts;
        this.userRatings = { isLiked, isDisliked, isFavourite };
        this.spotlights = spotlights;
        // video dashboard
        this.tag = tag;
        // Make chat stream scrollable
        setTimeout(() => {
          if ($(window).width() >= 992) {
            $('.discussion').css({
              'height': $('.video-section').innerHeight()
            });
          }
        }, 500);
      });
    } else {
      this.dashboardService.getVideoDetail(videoId).subscribe((data: any) => {
        const { spotlights, ratingCounts, isLiked, tag, isDisliked, isFavourite } = data.data;
        if(from=='manual'){
          this.currentVideoDetail = data.data;
          this.pathwayDetail = { title: data.data.title, description: data.data.description, tagName: data.data.tag.name };
        }
        this.ratingCounts = ratingCounts;
        this.userRatings = { isLiked, isDisliked, isFavourite };
        this.spotlights = spotlights;
        // video dashboard
        this.tag = tag;
        // Make chat stream scrollable
        setTimeout(() => {
          if ($(window).width() >= 992) {
            $('.discussion').css({
              'height': $('.video-section').innerHeight()
            });
          }
        }, 500);
      });
      this.getTrackedVideoWatchDashboard(videoId);
    }

    
    this.cd.detectChanges();
    // this.dashboardService.getTrackedVideoWatch(videoId).subscribe((data: any) => {
    //   this.trackVideoDetail = data.data;
    //   this.contentProcessed.data = data.data.percentage;
    // });
  }

  /**
   * Get video watched status
   * @param videoId videoid watched status
   */
  getTrackedVideoWatchDashboard(videoId) {
    this.dashboardService.getTrackedVideoWatch(videoId).subscribe((data: any) => {
      this.trackVideoDetail = data.data;
      this.contentProcessed.data = data.data.percentage;
    });
  }

  /**
   * On playlist click
   * @param video video to be played
   */
  onPlaylistClick(video) {
    this.isDashboard = false;
    this.currentVideoDetail = video;
    this.videoId = video._id;
    this.getVideoDetail(video._id);
    this.pathwayDetail = { title: video.title, description: video.description, tagName: video.tag.name, videoURL : video.videoURL };
  }

  /**
   * laod dashboard overview page
   */
  onDashboardClick() {
    this.isDashboard = true;
    this.currentVideoDetail = {};
    this.trackVideoDetail = {};
    this.getOverviewDetail();
  }

  /** call footer event */
  callFooterCommonEvent() {
    this.commonService.raiseDashboardFooterEvent(this.isDashboard);
  }

  /**
  * Show video description modal
  */
  openSpotLightModal() {
    $("#spotlight").appendTo('body').modal('show');
  }

  /**
   * Called when update consumed content
   * @param data data to be tracked
   */
  onUpdateConsumedContent(data) {
    this.dashboardService.trackVideoWatch(data).subscribe((data: any) => {
      // Update consumed percentage
      const { percentage } = data.data;
      this.contentProcessed.data = percentage;
    });
  }

  /**
   * Load next video
   */
  loadNextVideo() {
    // Get current video position from playlist
    const currentVideoIndex = this.playlists.findIndex((playlist) => { return playlist._id == this.videoId });
    // Check video position available and video on next position is available then play next video
    if (currentVideoIndex != -1 && currentVideoIndex < (this.playlists.length - 1)) {
      this.onPlaylistClick(this.playlists[currentVideoIndex + 1]);
    }
  }

  /**
   * Handle change view subscription
   */
  handleChangeViewSubscription() {
    this.changeViewSubscription = this.commonService.onChangeView.subscribe((viewName: string) => {

      switch (viewName) {
        case 'dashboardOverview':
          this.showForumView = false;
          this.showForumQuestionView = false;
          this.showDashboardOverviewView = true;
          break;
        case 'forum':
          this.showForumView = true;
          this.showForumQuestionView = false;
          this.showDashboardOverviewView = false;
          break;
        case 'question':
          this.showForumQuestionView = true;
          this.showForumView = false;
          this.showDashboardOverviewView = false;
          break;
        default:
      }
    });
  }

  callback(entries, observer) {
    entries.forEach(entry => {
      // Each entry describes an intersection change for one observed
      // here you animate another element and do whatever you like
    });
  }

  /**
   * Update overview image url if given url is not valid
   * @param event
   */
  updateOverviewImageUrl(event) {
    this.overviewImageUrl = "assets/img/videos/main-iamge.png";
  }
}
